<template>
  <div class="editorOption">
    <ZoomSlider @change="change" :init="zoomSize" :min="0.2" :max="2"/>
    <slot></slot>
  </div>
</template>

<script>
import ZoomSlider from '@common/ZoomSlider.vue'

export default {
  props: {
    diagram: Object,
    zoomSize: {type:Number, default:1},
  },
  data () {
    return {
    }
  },
  watch: {
    diagram(value) {
      this.diagram.scale = this.$props.zoomSize;
      this.diagram.addDiagramListener('ViewportBoundsChanged', (event, node) => {
        this.$emit("update:zoomSize",Number(this.diagram.scale));
      })
    }
  },
  components: { ZoomSlider },
  mounted () {
    
  },
  methods: {
    change (event) {
      this.diagram.scale = event;
    }
  }
}

</script>

<style lang="scss">
  .editorOption {
    display: flex; align-items: flex-start; 
    gap:5px;
    position: absolute; top: 0; right: 0px;
    // padding: var( --default-gap );
    // padding-right: 40px; 
    padding: 20px;
    z-index: 15;

    .optWrap {
      --gap: 8px; 
      --size: 32px; 
      position: fixed; bottom:50px; right:20px;
      display: flex; 
      flex-wrap: wrap; 
      width: 116px; 
      gap: var( --gap ); 
      z-index: 92;
      > button , > a {
        display: flex; 
        border: 1px solid $gray-d; 
        width: 100%; 
        height: var( --size ); 
        justify-content: center; 
        align-items: center; 
        font-size: 14px; 
        color: $gray-3; 
        @include text-prt-sb; 

        &.docOption {
          width: calc( 100% - var( --size ) - var( --gap )); 
        } 
        &.historyList {
          font-size: 0; 
          background: url('@/assets/icons/clock.svg') no-repeat center center; 
          width: 32px; 
          flex-shrink: 0; 
        }
        &.historySave {
          background-color: $gray-e; 
          
        }
      }
    } // 

    .template {
      display: inline-flex; align-items: center; justify-content: center;
      min-width:80px; height: 32px;
      padding: 8px 16px;
      color: $gray-6; 
      font-size: 14px; 
      background-color: $white; 
      border-radius: 3px; 
      border: 1px solid #ddd;
      cursor: pointer; 
    }

  } // end of .editorOption

  /*
  .docOption {
    display: flex; align-items: center; justify-content: center;
    min-width: 80px; min-height: 32px;
    border: 1px solid $gray-d;
    background-color: $white;
    font-size: 14px;
  }
  .historyList {
    border: 1px solid $gray-d;
  } 
  */


</style>